<template>
  <div
    class="entity-box"
    :class="{
      'entity-box--deletable': deletable
      , 'entity-box--draggable': draggable
    }"
  >
    <div
      v-b-tooltip.hover.bottom="{
        delay: { show: 200, hide: 0 },
        title: title,
        fallbackPlacement: ['bottom'],
        boundary: 'window',
        noninteractive: true,
        disabled: tooltipDisable
      }"
      :aria-label="`${$t('common.tooltip')} ${title}`"
    >
      <div
        ref="widthTester"
        class="entity-box__title"
        :class="{ 'entity-box__title--draggble': draggable }"
      >
        <slot />
      </div>
    </div>
    <div
      v-if="deletable"
      ref="deleteButton"
      class="entity-box__delete"
      :aria-label="`${$t('common.remove')} ${title}`"
      data-testid="delete"
      @click="handleDelete()"
    >
      <elIcon name="x" />
    </div>
  </div>
</template>

<script>
import elIcon from './elIcon.vue'
import { VBTooltip } from '@ui/components'

export default {
  components: {
    elIcon
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete'],
  data: function() {
    return {
      tooltipDisable: true,
      maxButtonWidth: 192
    }
  },
  mounted() {
    const cWidth = this.$refs.widthTester.clientWidth
    if (cWidth && cWidth === this.maxButtonWidth) {
      this.tooltipDisable = false
    }
  },
  methods: {
    handleDelete() {
      this.$emit('delete', this.value)
    }
  }
}
</script>

<style lang="scss">
@import "~@ui/styles/src/scss/utils/lib";

$maxButtonWidth: 192px;

@mixin hover {
  box-shadow: 0 1px 3px $black20percent;
}

.entity-box {
  $this: &;

  position: relative;
  display: inline-block;
  padding: 0.5rem;
  border: 1px solid $lightTextColor;
  border-radius: 0.125rem;

  &--deletable {
    &:hover {
      @include hover;
    }

    @at-root {
      #{$this}__delete {
        position: absolute;
        top: -1px;
        right: -24px;
        bottom: -1px;
        z-index: 1;
        display: none;
        align-items: center;
        justify-content: center;
        width: 24px;
        color: scale-color($neutralGray, $lightness: 30%);
        line-height: 100%;
        background-color: #efefef;
        border-top-right-radius: 0.125rem;
        border-bottom-right-radius: 0.125rem;
        cursor: pointer;

        #{$this}:hover & {
          display: flex;
          box-shadow: 0 1px 3px $black20percent;
        }

        &:hover {
          color: #000;
        }
      }
    }
  }

  &--draggable {
    cursor: move;
    cursor: grab;

    &:hover {
      @include hover;
    }

    &::before {
      position: absolute;
      top: 4px;
      bottom: 4px;
      left: 3px;
      display: block;
      width: 6px;
      background-image: $dragHandleImage;
      opacity: 0.4;
      content: '';
    }
  }

  &__title {
    @include overflow-ellipsis;

    max-width: $maxButtonWidth;
    font-weight: 100;

    #{$this}--draggable & {
      margin-left: 0.5rem;
    }
  }
}
</style>

